import { useRouter } from "next/router";
import { useMemo } from "react";
/**
 * 링크에서 경로만 추출 (쿼리스트링 및 도메인 제거)
 * - 상대 경로: /categories/edition/ebs?id=12 → /categories/edition/ebs
 * - 절대 URL: https://example.com/categories/edition/ebs?id=12 → /categories/edition/ebs
 */ const getPathFromLink = (link)=>{
    try {
        // 절대 URL인 경우 pathname만 추출
        if (link.startsWith("http://") || link.startsWith("https://")) {
            const url = new URL(link);
            return url.pathname;
        }
        // 상대 경로인 경우 쿼리스트링만 제거
        const questionMarkIndex = link.indexOf("?");
        return questionMarkIndex === -1 ? link : link.slice(0, questionMarkIndex);
    } catch (e) {
        // URL 파싱 실패 시 기존 로직 사용
        const questionMarkIndex = link.indexOf("?");
        return questionMarkIndex === -1 ? link : link.slice(0, questionMarkIndex);
    }
};
/**
 * 현재 URL 경로가 마케팅 탭(쏠북패스, 브랜드관 등) 링크와 매칭되는지 확인하는 훅
 * - 마케팅 탭 활성화 시 과목 탭(Tabs)은 비활성화되어야 함
 */ export const useActiveMarketingTab = (marketingTabs)=>{
    const { asPath  } = useRouter();
    // asPath에서 쿼리스트링 제거하여 순수 경로만 추출
    const pathname = getPathFromLink(asPath);
    // 현재 경로와 매칭되는 마케팅 탭 ID
    const activeTabId = useMemo(()=>{
        const isMatch = (targetLink)=>{
            const targetPath = getPathFromLink(targetLink);
            return pathname === targetPath || pathname.startsWith("".concat(targetPath, "/"));
        };
        const activeTab = marketingTabs.find((tab)=>{
            var _tab_items;
            // tabUrl 매칭 (쿼리스트링 제외)
            if (tab.tabUrl && isMatch(tab.tabUrl)) {
                return true;
            }
            // items 링크 매칭 (쿼리스트링 제외)
            return (_tab_items = tab.items) === null || _tab_items === void 0 ? void 0 : _tab_items.some((item)=>isMatch(item.itemLink));
        });
        var _activeTab_id;
        return (_activeTab_id = activeTab === null || activeTab === void 0 ? void 0 : activeTab.id) !== null && _activeTab_id !== void 0 ? _activeTab_id : null;
    }, [
        pathname,
        marketingTabs
    ]);
    // 마케팅 탭이 활성화되어 있는지 여부
    const isMarketingTabActive = activeTabId !== null;
    return {
        activeTabId,
        isMarketingTabActive
    };
};
